import { useController, useFormContext } from 'react-hook-form';
import {
  FieldWrapper,
  Label,
  MultiSelect,
  Typography,
} from '@ghq-abi/design-system-v2';

interface MultiSelectHookFormProps
  extends React.ComponentPropsWithoutRef<typeof MultiSelect> {
  name: string;
  label: string;
}

export function MultiSelectHookForm({
  name,
  label,
  ...props
}: Readonly<MultiSelectHookFormProps>) {
  const { control, formState } = useFormContext();
  const { field } = useController({
    control,
    name,
  });

  const hasError = !!formState.errors[name];

  return (
    <div className="space-y-2">
      <Label htmlFor={name}>
        <Typography variant="metadata-sm-regular" color="light">
          {label}
        </Typography>
      </Label>
      <FieldWrapper type={hasError ? 'error' : undefined}>
        <MultiSelect
          id={name}
          {...props}
          {...field}
          value={field.value}
          onValueChange={field.onChange}
        />
      </FieldWrapper>
    </div>
  );
}
